import React, { FunctionComponent } from "react";
import { IIconProps } from "./icon";

export const AttentionIcon: FunctionComponent<IIconProps> = (props) => {
  const { color, outlined, ...rest } = props;
  return (
    <svg viewBox="0 0 40 40" {...rest}>
      <g id="Icons/Gene-Story/Attention" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <circle id="Oval" fill="#82BECC" cx="20" cy="20" r="20"></circle>
        <g
          id="streamline-icon-alert-diamond@24x24"
          transform="translate(9.000000, 9.000000)"
          stroke="#FFFFFF"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
        >
          <path
            d="M11.2499455,15.7501038 C11.0428387,15.7501038 10.8749455,15.917997 10.8749455,16.1251038 C10.8749455,16.3322105 11.0428387,16.5001038 11.2499455,16.5001038 C11.4570523,16.5001038 11.6249455,16.3322105 11.6249455,16.1251038 C11.6249455,15.917997 11.4570523,15.7501038 11.2499455,15.7501038 L11.2499455,15.7501038"
            id="Path"
          ></path>
          <line x1="11.2499455" y1="12.7501038" x2="11.2499455" y2="5.25010376" id="Path"></line>
          <path
            d="M0.529945496,12.5311038 C-0.176648499,11.823652 -0.176648499,10.6775556 0.529945496,9.97010376 L9.9699455,0.531103763 C10.3091366,0.19108821 10.7696735,0 11.2499455,0 C11.7302175,0 12.1907544,0.19108821 12.5299455,0.531103763 L21.9699455,9.97010376 C22.6765395,10.6775556 22.6765395,11.823652 21.9699455,12.5311038 L12.5299455,21.9701038 C11.8228367,22.6765831 10.6770543,22.6765831 9.9699455,21.9701038 L0.529945496,12.5311038 Z"
            id="Path"
          ></path>
        </g>
      </g>
    </svg>
  );
};
